import { createContext, useContext, type ReactNode } from 'react';

type PlanModalContextValue = {
  /** Opens the subscription modal. Pass a plan slug to open pre-selected on that plan. */
  openPlanModal: (initialPlan?: string) => void;
};

const PlanModalContext = createContext<PlanModalContextValue | null>(null);

export const usePlanModal = () => {
  const ctx = useContext(PlanModalContext);
  if (!ctx) throw new Error('usePlanModal must be used inside PlanModalProvider');
  return ctx;
};

type PlanModalProviderProps = {
  children: ReactNode;
  onOpen: (initialPlan?: string) => void;
};

export const PlanModalProvider = ({ children, onOpen }: PlanModalProviderProps) => {
  return (
    <PlanModalContext.Provider value={{ openPlanModal: onOpen }}>
      {children}
    </PlanModalContext.Provider>
  );
};
